import { AuthContext } from '@repo-level/core-front';
import type { IDescription, IPromoDate, ITitle } from 'api/cms/cloverGoldPromo';
import { CloverGoldContext } from 'contexts/cloverGold';
import { useMatchingSection } from 'modules/common/hooks/useMatchingSection';
import { useContext } from 'react';
import {
  getCloverGoldAssets,
  getCloverGoldProgress,
  isCloverGoldFirstRoundBonus,
  isCloverGoldLvl3,
  isCloverGoldLvl4,
  isCloverGoldSecondRound,
  isPromoLastLvl,
} from '../helpers';
import { useIsCloverBonusIssued } from './useIsCloverBonusIssued';

export const useCloverGoldPromo = () => {
  const { user } = useContext(AuthContext);
  const { cloverGoldData, cloverGoldPending } = useContext(CloverGoldContext);

  const { isIssued } = useIsCloverBonusIssued();
  const isFirstRoundBonus = isCloverGoldFirstRoundBonus(user);
  const resetToL0 = isFirstRoundBonus && !isIssued;

  const promoAssets = getCloverGoldAssets(
    resetToL0 ? undefined : user,
    cloverGoldData?.lvlProgress
  );
  const userProgress = resetToL0 ? 0 : getCloverGoldProgress(user);
  const isLvl3 = isCloverGoldLvl3(user);
  const isLvl4 = isCloverGoldLvl4(user) && !resetToL0;
  const isLastLvl = isPromoLastLvl(user);

  const promoDate = useMatchingSection<IPromoDate>(
    cloverGoldData?.promoDates ?? []
  );

  const isSecondRound = isCloverGoldSecondRound(promoDate ?? undefined);

  const title =
    useMatchingSection<ITitle>(cloverGoldData?.titles ?? [])?.text ||
    cloverGoldData?.title;

  const description = useMatchingSection<IDescription>(
    cloverGoldData?.descriptions ?? []
  );

  return {
    promoAssets,
    userProgress,
    isLvl3,
    isLvl4,
    cloverGoldData,
    cloverGoldPending,
    isSecondRound,
    title,
    description,
    isLastLvl,
  };
};
